import React from 'react';

function ClinicSettingsEmpty({ icon, title, description, actionLabel, onAction }) {
    return (
        <div className="clinic-settings-empty ecx-page-empty">
            <div className="clinic-settings-empty__icon ecx-page-empty__icon">
                <i className={`bi ${icon}`}></i>
            </div>
            <h5 className="text-dark fw-semibold mb-2">{title}</h5>
            <p className="mb-3">{description}</p>
            {actionLabel && onAction && (
                <button type="button" className="btn btn-sm btn-light-primary rounded-pill" onClick={onAction}>
                    <i className="bi bi-plus-circle me-1"></i>
                    {actionLabel}
                </button>
            )}
        </div>
    );
}

export default ClinicSettingsEmpty;
